import React, { createContext, useState, useContext, useEffect } from 'react';

const themes = {
  light: {
    name: 'Light',
    background: '#f5f5f5',
    cardBackground: '#ffffff',
    headerBackground: '#CC0000',
    headerText: '#FFD700',
    text: '#111111',
    subText: '#888888',
    border: '#dddddd',
    checkboxAccent: '#CC0000',
    buttonPrimary: '#CC0000',
    buttonText: '#ffffff',
  },
  dark: {
    name: 'Dark',
    background: '#0d0d0d',
    cardBackground: '#1a1a1a',
    headerBackground: '#1a0000',
    headerText: '#cc3333',
    text: '#f0f0f0',
    subText: '#888888',
    border: '#2a2a2a',
    checkboxAccent: '#cc3333',
    buttonPrimary: '#cc3333',
    buttonText: '#ffffff',
  },
  yellow: {
    name: 'Yellow',
    background: '#1a1400',
    cardBackground: '#2a2200',
    headerBackground: '#FFD700',
    headerText: '#ffffff',
    text: '#ffffff',
    subText: '#ccbb00',
    border: '#ccaa00',
    checkboxAccent: '#cc8800',
    buttonPrimary: '#FFD700',
    buttonText: '#ffffff',
  },
  city: {
    name: 'City',
    background: '#1a0a0a',
    cardBackground: '#2d1010',
    headerBackground: '#6b0f1a',
    headerText: '#f5f0e8',
    text: '#f5f0e8',
    subText: '#c9a89a',
    border: '#8b1a1a',
    checkboxAccent: '#c41e3a',
    buttonPrimary: '#6b0f1a',
    buttonText: '#f5f0e8',
  },
  blues: {
    name: 'Blues',
    background: '#001433',
    cardBackground: '#002166',
    headerBackground: '#003399',
    headerText: '#FFB81C',
    text: '#ffffff',
    subText: '#99aacc',
    border: '#003B8E',
    checkboxAccent: '#FFB81C',
    buttonPrimary: '#4169E1',
    buttonText: '#FFB81C',
  },
  battlehawks: {
    name: 'Battlehawks',
    background: '#00050f',
    cardBackground: '#001a3a',
    headerBackground: '#002855',
    headerText: '#5b9bd5',
    text: '#ffffff',
    subText: '#7aaec8',
    border: '#004080',
    checkboxAccent: '#5b9bd5',
    buttonPrimary: '#1a4f8a',
    buttonText: '#ffffff',
  },
  cardinals: {
    name: 'Cardinals',
    background: '#1a0000',
    cardBackground: '#2a0000',
    headerBackground: '#C41E3A',
    headerText: '#FFD700',
    text: '#ffffff',
    subText: '#ffcccc',
    border: '#8B0000',
    checkboxAccent: '#FFD700',
    buttonPrimary: '#C41E3A',
    buttonText: '#FFD700',
  },
};

const THEME_BACKGROUNDS = {
  light: `url(/stl-cards-initials.png)`,
  dark: `url(/stl-cards-initials.png)`,
  yellow: `url(/stl-cards-initials-horizontal.png)`,
  city: `url(/stl-city-words.png)`,
  blues: `url(/stl-blue.png)`,
  battlehawks: `url(/stl-battlehawks.png)`,
  cardinals: `url(/stl-cards-bird.png)`,
};

const THEME_BG_SIZES = {
  light: '120px 120px',
  dark: '120px 120px',
  yellow: '120px 120px',
  city: '120px 120px',
  blues: '120px 120px',
  battlehawks: '120px 120px',
  cardinals: '120px 120px',
};

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [themeName, setThemeName] = useState(
    localStorage.getItem('theme') || 'light'
  );

  const theme = themes[themeName];
  const backgroundImage = THEME_BACKGROUNDS[themeName] || 'none';
  const backgroundSize = THEME_BG_SIZES[themeName] || 'auto';

  useEffect(() => {
    localStorage.setItem('theme', themeName);
  }, [themeName]);

  return (
    <ThemeContext.Provider value={{ theme, themeName, setThemeName, themes, backgroundImage, backgroundSize }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);